<it-modal #errorModal="itModal" alertModal="true">
	<it-icon name="error" color="danger" beforeTitle></it-icon>
	<ng-container modalTitle>{{
		error.title ?? ("it.errors.generic" | translate)
	}}</ng-container>
	<p
		[innerHTML]="
			error.detail ?? ('it.errors.generic-support-message' | translate)
		"
	></p>
	@if (error.status === 409) {
		<p>{{ "iterlex.ignore-constraint" | translate }}</p>
	}
	@if (error.status === 409) {
		<ng-container footer>
			<button
				itButton="primary"
				(click)="ignoreConstraints()"
				type="button"
				data-bs-dismiss="modal"
			>
				{{ "it.general.continue" | translate }}
			</button>
			<button
				itButton="outline-secondary"
				type="button"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.cancel" | translate }}
			</button>
		</ng-container>
	}
</it-modal>
